export default {
  props: {
    item: {
      required: true,
      type: Object
    }
  },
  data () {
    return {
      localItem: null
    }
  },
  created () {
    this.localItem = this.item
  }
}
